<script lang="ts" setup>
import { useI18n } from '@/plugins/i18n'
import SaiModal from '@/components/common/SaiModal/index.ce.vue';
import CheckBoxSingle from '@/components/common/SaiCheckBoxSingle/index.ce.vue';
import { ref, computed } from 'vue';
import { useSearchStore } from '@/components/Search/store/index.ts'
import SaiTooltip from '@/components/common/SaiTooltip/index.ce.vue';
//props
const props = defineProps({
    searchType: { type: String, default: '', required: false },
    saveForMonthlyAlerts: { type: Boolean, default: false, required: false }
});

//ref 
const showAlreadySavedTooltip = ref(false); 
const refAlreadySavedTooltip = ref<HTMLElement | null>(null);

//store
const searchStore = useSearchStore()

//translations
const i18nInstance: any = useI18n()
const { t } = i18nInstance

//refs
const display = ref(false);
const monthlyAlert = ref(false);
const saveSearchName = ref('');
const processing = ref(false);

// emits
const closeModal = () => {
  display.value = false;
}

const handleCheckForAlert = () => {
    monthlyAlert.value = !monthlyAlert.value;
}

const handleSaveSearch = async () => {
    if(saveSearchName.value.trim() === '') {
        alert(t('provideShortTitle'));
        return;
    }
    processing.value = true;
    let result = await searchStore.saveSearch({searchType: props.searchType, saveSearchNotify: monthlyAlert.value, saveSearchName: saveSearchName.value});
    if(result) {
        const decodedResult = new DOMParser().parseFromString(result, 'text/html').documentElement.textContent;
        alert(decodedResult);
    }
    monthlyAlert.value = false;
    saveSearchName.value = '';
    processing.value = false;
    display.value = false;
}
 
const isSearchSaved = computed(() => searchStore[`${props.searchType}.resultData`]?.isSavedSearch || 0);
const showSaveSearchModal = () => {
    if(!isSearchSaved.value) {
        display.value = true;
    }
}
</script>

<template>
    <div :class="['btn-save-search', isSearchSaved ? 'saved-already' : '']" @click="showSaveSearchModal" 
     ref="refAlreadySavedTooltip" 
    @mouseenter="isSearchSaved && (showAlreadySavedTooltip = true)" 
    @mouseleave="showAlreadySavedTooltip = false">
        {{ t('saveSearch') }}
        <SaiTooltip
              v-if="refAlreadySavedTooltip"
              v-model="showAlreadySavedTooltip"
              :target="refAlreadySavedTooltip"
              placement="top"
              :offset="8"
              :showArrow="false"
            >
            {{ t('searchAlreadySaved') }}
        </SaiTooltip>
    </div>
    <SaiModal :display="display" @closeModal="closeModal" className="save-search-modal" :processing="processing">
        <template #title>
            <div class="title-wrapper">
                <div class="main-title">{{ t('saveThisSearch') }}</div>
                <div class="sub-title">{{ t('save10Searches') }}</div>
            </div>
        </template>
        <template #body>
           <div class="save-search-body">
                <div class="input-group">
                    <label for="searchName">{{ t('title') }}<span>*</span></label>
                    <input type="text" id="searchName" name="searchName" placeholder="Give this search a short title" v-model="saveSearchName" autocomplete="off"/>
                </div>
                <div class="monthly-alerts" v-if="saveForMonthlyAlerts">
                    <CheckBoxSingle :checked="monthlyAlert" @onClick="handleCheckForAlert"/>
                    <label for="monthlyAlerts" @click="handleCheckForAlert">{{ t('enableMonthlyAlert') }}</label>
                </div>
                <div class="button-group">
                    <button class="btn-cancel" @click="closeModal">{{ t('cancel') }}</button>
                    <button class="btn-save" @click="handleSaveSearch">{{ t('saveSearch') }}</button>
                </div>
           </div>
        </template>
    </SaiModal>
</template>